import request from '@/utils/request'

export function getPublicActivity(activityId) {
  return request({
    url: `/api/activities/${activityId}`,
    method: 'get'
  })
}

export function loginActivity(activityId, data) {
  return request({
    url: `/api/activities/${activityId}/login`,
    method: 'post',
    data
  })
}

export function getActivityLessons(activityId) {
  return request({
    url: `/api/activities/${activityId}/lessons`,
    method: 'get'
  })
}

export function getActivityLessonPractice(activityId, lessonIndex) {
  return request({
    url: `/api/activities/${activityId}/lessons/${lessonIndex}`,
    method: 'get'
  })
}

export function completeActivityLesson(activityId, lessonIndex, data) {
  return request({
    url: `/api/activities/${activityId}/lessons/${lessonIndex}/complete`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/activity.js